module.exports = __webpack_public_path__ + "static/media/icon-gender.3ad7011a.svg";